const countriesToStoreUrlMapping = {
  Albania: {
    url: "en-al",
    country_code: "AL",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Algeria: {
    url: "en-dz",
    country_code: "DZ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Angola: {
    url: "en-ao",
    country_code: "AO",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Armenia: {
    url: "en-am",
    country_code: "AM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Australia: {
    url: "en-au",
    country_code: "AU",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  Austria: {
    url: "en-at",
    country_code: "AT",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Azerbaijan: {
    url: "en-az",
    country_code: "AZ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Bahrain: {
    url: "en-bh",
    country_code: "BH",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Belgium: {
    url: "en-be",
    country_code: "BE",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Bermuda: {
    url: "en-bm",
    country_code: "BM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Bolivia: {
    url: "en-bo",
    country_code: "BO",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Botswana: {
    url: "en-bw",
    country_code: "BW",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Brunei: {
    url: "en-bn",
    country_code: "BN",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Bulgaria: {
    url: "en-bg",
    country_code: "BG",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Cambodia: {
    url: "en-kh",
    country_code: "KH",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Canada: {
    url: "en-ca",
    country_code: "CA",
    currency_code: "CAD",
    currency_symbol: "$",
  },
  "Cayman Islands": {
    url: "en-ky",
    country_code: "KY",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Chile: {
    url: "en-cl",
    country_code: "CL",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Colombia: {
    url: "en-co",
    country_code: "CO",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Comoros: {
    url: "en-km",
    country_code: "KM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "Costa Rica": {
    url: "en-cr",
    country_code: "CR",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Croatia: {
    url: "en-hr",
    country_code: "HR",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Curaçao: {
    url: "en-cw",
    country_code: "CW",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Cyprus: {
    url: "en-cy",
    country_code: "CY",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Denmark: {
    url: "en-dk",
    country_code: "DK",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "Dominican Republic": {
    url: "en-do",
    country_code: "DO",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Ecuador: {
    url: "en-ec",
    country_code: "EC",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "El Salvador": {
    url: "en-sv",
    country_code: "SV",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Estonia: {
    url: "en-ee",
    country_code: "EE",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Ethiopia: {
    url: "en-et",
    country_code: "ET",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Fiji: {
    url: "en-fj",
    country_code: "FJ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Finland: {
    url: "en-fi",
    country_code: "FI",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  France: {
    url: "en-fr",
    country_code: "FR",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Gambia: {
    url: "en-gm",
    country_code: "GM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Germany: {
    url: "en-de",
    country_code: "DE",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Ghana: {
    url: "en-gh",
    country_code: "GH",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Greenland: {
    url: "en-gl",
    country_code: "GL",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Guadeloupe: {
    url: "en-gp",
    country_code: "GP",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Guatemala: {
    url: "en-gt",
    country_code: "GT",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Guyana: {
    url: "en-gt",
    country_code: "GY",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Honduras: {
    url: "en-hn",
    country_code: "HN",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "Hong Kong": {
    url: "en-hk",
    country_code: "HK",
    currency_code: "USD",
    currency_symbol: "$",
    address_value_alias: "Hong Kong",
  },
  Hungary: {
    url: "en-hu",
    country_code: "HU",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Iceland: {
    url: "en-is",
    country_code: "IS",
    currency_code: "USD",
    currency_symbol: "$",
  },
  India: {
    url: "en-in",
    country_code: "IN",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Iraq: {
    url: "en-iq",
    country_code: "IQ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Ireland: {
    url: "en-ie",
    country_code: "IE",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Italy: {
    url: "en-it",
    country_code: "IT",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Jamaica: {
    url: "en-jm",
    country_code: "JM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Japan: {
    url: "en-jp",
    country_code: "JP",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Jordan: {
    url: "en-jo",
    country_code: "JO",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Kenya: {
    url: "en-ke",
    country_code: "KE",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Kuwait: {
    url: "en-kw",
    country_code: "KW",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Kyrgyzstan: {
    url: "en-kg",
    country_code: "KG",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Latvia: {
    url: "en-lv",
    country_code: "LV",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Luxembourg: {
    url: "en-lu",
    country_code: "LU",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Madagascar: {
    url: "en-mg",
    country_code: "MG",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Malawi: {
    url: "en-mw",
    country_code: "MW",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Maldives: {
    url: "en-mv",
    country_code: "MV",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Malta: {
    url: "en-mt",
    country_code: "MT",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Martinique: {
    url: "en-mq",
    country_code: "MQ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Mauritania: {
    url: "en-mr",
    country_code: "MR",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Moldova: {
    url: "en-md",
    country_code: "MD",
    currency_code: "USD",
    currency_symbol: "$",
    address_value_alias: "Moldova, Republic of",
  },
  Montenegro: {
    url: "en-me",
    country_code: "ME",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Mozambique: {
    url: "en-mz",
    country_code: "MZ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Nepal: {
    url: "en-np",
    country_code: "NP",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Netherlands: {
    url: "en-nl",
    country_code: "NL",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  "New Caledonia": {
    url: "en-nc",
    country_code: "NC",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "New Zealand": {
    url: "en-nz",
    country_code: "NZ",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Nigeria: {
    url: "en-ng",
    country_code: "NG",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Norway: {
    url: "en-no",
    country_code: "NO",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Oman: {
    url: "en-om",
    country_code: "OM",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Panama: {
    url: "en-pa",
    country_code: "PA",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "Papua New Guinea": {
    url: "en-pg",
    country_code: "PG",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Paraguay: {
    url: "en-py",
    country_code: "PY",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Philippines: {
    url: "en-ph",
    country_code: "PH",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Poland: {
    url: "en-pl",
    country_code: "PL",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Portugal: {
    url: "en-pt",
    country_code: "PT",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Qatar: {
    url: "en-qa",
    country_code: "QAT",
    currency_code: "QAR",
    currency_symbol: "ر.ق",
  },
  Romania: {
    url: "en-ro",
    country_code: "RO",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  "Saudi Arabia": {
    url: "en-sa",
    country_code: "SA",
    currency_code: "SAR",
    currency_symbol: "ر.س",
  },
  Singapore: {
    url: "en-sg",
    country_code: "SG",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "Sint Maarten": {
    url: "en-sx",
    country_code: "SX",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Slovakia: {
    url: "en-sk",
    country_code: "SK",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Slovenia: {
    url: "en-si",
    country_code: "SI",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  "South Africa": {
    url: "en-za",
    country_code: "ZA",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "South Korea": {
    url: "en-kr",
    country_code: "KR",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Spain: {
    url: "en-es",
    country_code: "ES",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  "Sri Lanka": {
    url: "en-lk",
    country_code: "LK",
    currency_code: "USD",
    currency_symbol: "$",
  },
  "St. Lucia": {
    url: "en-lc",
    country_code: "LC",
    currency_code: "USD",
    currency_symbol: "$",
    address_value_alias: "Saint Lucia",
  },
  Suriname: {
    url: "en-sr",
    country_code: "SR",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Sweden: {
    url: "en-se",
    country_code: "SE",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Switzerland: {
    url: "en-ch",
    country_code: "CH",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  Taiwan: {
    url: "en-tw",
    country_code: "TW",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Tanzania: {
    url: "en-tz",
    country_code: "TZ",
    currency_code: "USD",
    currency_symbol: "$",
    address_value_alias: "Tanzania, United Republic Of",
  },
  "United Arab Emirates": {
    url: "en-ae",
    country_code: "AE",
    currency_code: "AED",
    currency_symbol: "د.إ",
  },
  "United Kingdom": {
    url: "en-gb",
    country_code: "GB",
    currency_code: "GBP",
    currency_symbol: "£",
  },
  "United States": {
    url: "en-us",
    country_code: "US",
    currency_code: "USD",
    currency_symbol: "$",
  },
  Vietnam: {
    url: "en-vn",
    country_code: "VN",
    currency_code: "USD",
    currency_symbol: "$",
  },
};

function renderCountries(countriesToStoreUrlMapping, currentCountryCode, countriesList) {
  countriesList.innerHTML = "";
  const countryListPrefix = countriesList.dataset.countryListPrefix || "country";
  Object.entries(countriesToStoreUrlMapping).forEach(([name, data]) => {
    const li = document.createElement("li");
    li.className = "disclosure__item";
    li.tabIndex = -1;

    const isCurrent = data.country_code === currentCountryCode;

    const el = document.createElement(isCurrent ? "span" : "a");
    el.className = "link link--text disclosure__link caption-large focus-inset";
    el.dataset.value = data.country_code;
    el.id = `${countryListPrefix}-${data.country_code.toLowerCase()}`;

    if (isCurrent) {
      el.setAttribute("aria-current", "true");
      el.setAttribute("aria-disabled", "true");
      el.classList.add("is-current");
    } else {
      el.href = window.location.origin + "/" + (data.url || "");
    }

    // Checkmark span (only visible for current country)
    const checkmarkSpan = document.createElement("span");
    if (!isCurrent) checkmarkSpan.className = "visibility-hidden";
    checkmarkSpan.innerHTML =
      '<svg class="icon-checkmark" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7656 0.234375C11.4531 -0.078125 10.9375 -0.078125 10.6406 0.234375L3.75 7.10938L1.35938 4.73438C1.04688 4.42188 0.53125 4.42188 0.234375 4.73438C-0.078125 5.04688 -0.078125 5.5625 0.234375 5.85938L3.23438 8.85938C3.39062 9.01562 3.57812 9.09375 3.75 9.09375C3.92188 9.09375 4.125 9.01562 4.26562 8.85938L11.7656 1.35938C12.0781 1.04688 12.0781 0.53125 11.7656 0.234375Z" fill="currentColor"/></svg>';

    // Country name
    const countrySpan = document.createElement("span");
    countrySpan.className = "country";
    countrySpan.textContent = name;

    // Currency
    const currencySpan = document.createElement("span");
    currencySpan.className = "localization-form__currency motion-reduce";
    currencySpan.textContent = `(${data.currency_code} ${data.currency_symbol})`;

    el.appendChild(checkmarkSpan);
    el.appendChild(countrySpan);
    el.appendChild(currencySpan);
    li.appendChild(el);
    countriesList.appendChild(li);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  window.countriesToStoreUrlMapping = countriesToStoreUrlMapping;
  const currentCountryCode = document.querySelector("[data-current-country-code]")?.value || "US";
  const countriesLists = document.getElementsByClassName("countries-selector");
  for (const countryList of countriesLists) {
    renderCountries(countriesToStoreUrlMapping, currentCountryCode, countryList);
  }

  const LS_KEY_LAST_COUNTRY = "hb:lastCountry";
  const LS_KEY_CLEAR_LOCK = "hb:cartClearLock";
  const LOCK_TTL_MS = 12000;

  function acquireLock() {
    try {
      const now = Date.now();
      const raw = localStorage.getItem(LS_KEY_CLEAR_LOCK);
      if (raw) {
        const { ts } = JSON.parse(raw);
        if (now - ts < LOCK_TTL_MS) return false;
      }
      localStorage.setItem(LS_KEY_CLEAR_LOCK, JSON.stringify({ ts: now }));
      return true;
    } catch (_) {
      return true;
    }
  }
  function releaseLock() {
    try {
      localStorage.removeItem(LS_KEY_CLEAR_LOCK);
    } catch (_) {}
  }

  async function clearCartFast() {
    try {
      if (typeof window.clearCart === "function") {
        await window.clearCart({ timeoutMs: 8000, silent: true });
      } else {
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          keepalive: true,
        });
      }
    } catch (e) {
      console.warn("[CountryGate] clearCart failed (non-blocking):", e);
    }
  }

  async function ensureCountryInitialized() {
    let saved = null;
    try {
      saved = localStorage.getItem(LS_KEY_LAST_COUNTRY);
    } catch (_) {}

    const mustClear = !saved || saved !== currentCountryCode;

    if (mustClear && acquireLock()) {
      const cartPageContainer = document.getElementById("MainContentContainer");
      try {
        await clearCartFast();
      } finally {
        releaseLock();
      }
      const cartItems = document.querySelector("cart-items");
      if (cartItems && typeof cartItems.updateCartPage === "function") {
        await cartItems.updateCartPage();
      }
      if (cartPageContainer) {
        cartPageContainer.classList.remove("cart-page-processing");
      }
      if (typeof window.updateCartUI === "function") {
        await window.updateCartUI(false);
      }
    }

    try {
      localStorage.setItem(LS_KEY_LAST_COUNTRY, currentCountryCode);
    } catch (_) {}
  }

  window.beforeCountryChange = async () => {
    if (acquireLock()) {
      try {
        await clearCartFast();
      } finally {
        releaseLock();
      }
    }
  };

  ensureCountryInitialized();
});
